import React from "react";

export type IntoIconProps = {};

export const IntoIcon: React.FC<IntoIconProps> = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={"IntoIcon"}
    >
      <path
        d="m18.5 18 2.5-3m0 0-2.5-3m2.5 3H9"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
